// Module
var code = "<td class=\"timewriting-table-column__value\"> <div class=\"timewriting-table-mobile-label\" data-bind=\"text: _cell.Label\"></div> <span> <input type=\"checkbox\" data-bind=\"checked: _cell.Value, uniform: _cell.Value\"/> </span> </td>";
// Exports
export default code;